import { Button } from "@mui/material";
import { cvToJSON, hexToCV } from "@stacks/transactions";
import { useEffect, useState } from "react";

const appOrigin = window.location.origin;
const LoadMoreOriginChimes = ({ chimeResults, originChimes, loadChimes }) => {
    const [show, setShow] = useState(false);
    const [alertSelect, setAlertSelect] = useState(0);
    const [prevChimesLength, setPrevChimesLength] = useState(0);
    const alert = ['Find More', 'Keep Looking?', 'No More Results'];

    function handleLoadMore() {
        if (prevChimesLength === chimeResults.length) {
            setAlertSelect(2);
            return;
        }
        setAlertSelect(alertSelect + (alertSelect === 1 ? 0 : 1))
        loadChimes();
        setPrevChimesLength(chimeResults.length);
    }

    useEffect(() => {
        if (originChimes) {
            const checkFilter = chimeResults.filter(({ contract_log: { value: { hex } } }) => {
                const { "alt-origin": altOrigin } = cvToJSON(hexToCV(hex)).value;
                if (altOrigin?.value?.value !== appOrigin) return false;
                return null
            });
            console.log(chimeResults, checkFilter)
            if (checkFilter.length === 0) {
                setShow(true);
            } else {
                setShow(false);
            }
        }
    }, [chimeResults, originChimes])

    return (
        <>
            {show && originChimes && <Button onClick={handleLoadMore}>{alert[alertSelect]}</Button>}
        </>
    );
}

export default LoadMoreOriginChimes;